import React, { useState } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const VerifyCodeModal = ({ show, handleClose }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const { t } = useTranslation();

  return (
    <Modal show={show} onHide={handleClose} centered className="verify-code-modal credential-sec">
      <Modal.Header className="border-0 p-0 pb-3">
        <Link to="/sign-in" className="back-btn d-flex align-items-center gap-1">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.7501 18.75L9.00012 12L15.7501 5.25" stroke="#313131" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          {t("backToLogin")}
        </Link>
      </Modal.Header>

      <Modal.Body className="p-0">
        <div className="modal-start-sec">
          <h2 className="m-0">{t("verifyCodeTitle")}</h2>
          <p className="mt-0 mb-4">{t("verifyCodeMessage")}</p>

          <Form className="form-sec">
            <div className="position-relative mb-3">
              <FloatingLabel controlId="password" label={t("enterCode")}>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("enterCode")}
                />
              </FloatingLabel>
              <i
                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} position-absolute top-50 end-0 translate-middle-y me-3`}
                style={{ cursor: "pointer" }}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>

            <div className="form-check ps-0">
              <Form.Label className="form-check-label ps-0">
                {t("noCode")}{" "}
                <Button
                  variant="link"
                  className="text-red btn-for p-0 text-decoration-none border-0"
                  onClick={() => alert(t("codeResent"))}
                >
                  {t("resend")}
                </Button>
              </Form.Label>
            </div>
          </Form>
        </div>
      </Modal.Body>

      <Modal.Footer className="p-0 m-0 border-0">
        <Link to="/" className="btn btn-primary w-100">
          {t("verifyEmailBtn")}
        </Link>
      </Modal.Footer>
    </Modal>
  );
};

export default VerifyCodeModal;
